export enum NotificationStatus {
    // Отправленный
    Sent = 0,
    // Прочитанный
    Read = 1,
    // Прочитанный
    Error = 2,
}